import React, { FC } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import RadioField from 'buyside/components/presentation/Fields/radioField';

import { COMMUNITY, ALLOCATOR, FILTERED_ALLOCATOR } from 'buyside/util/fundProfileConstants';

import {
  UpdateFundProfileSectionVisibilityMutationVariables,
  useUpdateFundProfileSectionVisibilityMutation
} from 'interfaces/graphql-typings';

import styles from './visibilityFormStyles.scss';

const VisibilityForm: FC<{
  fundProfileId: string;
  openBlocklistModal: () => void;
  section: string;
  sectionVisibility: string;
}> = ({ fundProfileId, openBlocklistModal, section, sectionVisibility }) => {
  const [updateSectionVisibility] = useUpdateFundProfileSectionVisibilityMutation();

  const methods = useForm<UpdateFundProfileSectionVisibilityMutationVariables>({
    values: { employerProfileId: fundProfileId, section, sectionVisibility }
  });

  const radioOptions = [
    {
      label: 'Allocators Only: viewable by members approved as Capital Allocators',
      value: ALLOCATOR
    },
    {
      label: (
        <>
          Filtered Allocators: viewable by members approved as Capital Allocators and not on your{' '}
          <Button
            buttonType={BUTTON_TYPES.BUTTON}
            className={styles.blocklistButton}
            onClick={openBlocklistModal}
            text="fund's blocklist"
            type={BUTTON_TYPES.LINK}
          />
        </>
      ),
      value: FILTERED_ALLOCATOR
    },
    {
      label: 'SumZero Community: viewable by all Buyside members',
      value: COMMUNITY
    }
  ];

  const handleChange = methods.handleSubmit(variables => updateSectionVisibility({ variables }));

  return (
    <FormProvider {...methods}>
      <form className={styles.visibilityForm} onChange={handleChange}>
        <h4 className={styles.visibilityFormHeader}>Privacy</h4>
        <RadioField name="sectionVisibility" options={radioOptions} size="small" />
      </form>
    </FormProvider>
  );
};

export default VisibilityForm;
